// test497
(497 && 0);
